import Decimal from 'decimal.js';

export const coaleseDecimal = (value: string | null | undefined) => new Decimal(value ?? 0).toNumber();
